(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // BAD TRAIL DECISIONS: remember the exact product card before leaving a real collection.
  // This updates the CURRENT collection history entry (not the product URL), so native Back
  // returns to /collections/<handle>#<card-id>. The existing restore code below then scrolls
  // directly to that card, while scroll-container.js preserves the precise desktop scrollTop.
  document.addEventListener('click', (event) => {
    const productLink = event.target.closest('product-card a.product-card__link, .product-grid__item a[href*="/products/"]');
    if (!productLink) return;

    const card = productLink.closest('.product-grid__item');
    if (!card?.id) return;

    try {
      const current = new URL(window.location.href);
      current.hash = card.id;
      const state = typeof history.state === 'object' && history.state !== null ? history.state : {};
      history.replaceState(state, '', current.toString());
    } catch (_) {}
  }, true);

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
